<template>
  <span class="progress-parent">
    <VProgressLinear
      v-easy-tooltip="{ text: props.tooltip, disabled: !props.tooltip, offset: 3 }"
      :bg-color="props.color"
      :color="props.color"
      :model-value="props.ratio"
      :striped="props.striped"
      :height="props.height"
      :rounded="props.rounded"
      :bg-opacity="props.bgOpacity"
    />
  </span>
</template>

<script setup lang="ts">
import { VuetifyColors } from "@/src/easy-ui/types";

interface Props {
  ratio: number;
  striped?: boolean;
  tooltip?: string;
  color?: VuetifyColors;
  height?: string;
  rounded?: string;
  bgOpacity?: number;
}

const props = withDefaults(defineProps<Props>(), {
  striped: false,
  tooltip: "",
  color: VuetifyColors.Primary,
  height: "6",
  rounded: "12",
  bgOpacity: undefined,
});
</script>
